import useCaseOne from "../../../../hooks/useCaseOne";

const useIsReported = () => {
    const {is_reported = false} = useCaseOne();

    return is_reported;
};

export default useIsReported;